var FundingProfileType = /* @__PURE__ */ ((FundingProfileType2) => {
  FundingProfileType2["Bank"] = "bank";
  FundingProfileType2["EWallet"] = "e-wallet";
  return FundingProfileType2;
})(FundingProfileType || {});
export {
  FundingProfileType
};
